var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "relogio icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 16,
    cy: 15.9999,
    r: 15.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 324",
    x: 14,
    y: 16.9999,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 325",
    x: 14,
    y: 17.9999,
    width: 10,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 14 17.9999)",
    fill: "#D91F05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorario);
export default __webpack_public_path__ + "static/media/horario.117e09978d0cf84affcc96f5c9ae3eec.svg";
export { ForwardRef as ReactComponent };